import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class UpdateBijbEventErrorAction implements Action {
  public static readonly type = 'UpdateBijbEventErrorAction';

  constructor(public error: BijbError) {
  }

  public type = UpdateBijbEventErrorAction.type;
}
